/* eslint-disable @typescript-eslint/no-use-before-define */
/**
 * Go-style error handling
 * @param fn - A function that returns a value or throws an error
 * @returns A tuple with the value and undefined if the function succeeded, or undefined and the error if the function threw an error
 */
export function tryCatch<T, E = unknown>(
  fn: () => Promise<T>,
): Promise<SafeResult<T, E>>
export function tryCatch<T, E = unknown>(fn: () => T): SafeResult<T, E>
export function tryCatch<T, E = unknown>(p: Promise<T>): SafeResult<T, E>

export function tryCatch<T, E = unknown>(
  fn: (() => T) | (() => Promise<T>) | Promise<T>,
): SafeResult<T, E> | Promise<SafeResult<T, E>> {
  try {
    const maybePromise = typeof fn === 'function' ? fn() : fn
    if (isPromise(maybePromise)) {
      return maybePromise
        .then<SafeResult<T, E>>((v) => [v, undefined])
        .catch((err) => [undefined, err as E])
    }

    return [maybePromise, undefined]
  } catch (err) {
    return [undefined, err as E]
  }
}

export type SafeResult<T, E = unknown> = [T, undefined] | [undefined, E]

const isPromise = <T>(value: T | Promise<T>): value is Promise<T> => {
  return Promise.resolve(value) === value
}
